const Notify = {
  loader: (loading, message) => {
    Notify.stop();
    var so = {
      title: "Loading",
      body: message ? message : "Please wait while data is loading",
      mode: "loader"
    };

    if (loading)
      Notify.start(so);
    else
      Notify.stop();
  },
  prompt: (callback, message) => {
    var so = {
      title: "Warning",
      body: message ? message : "Are you sure you want to continue?",
      mode: "prompt"
    };

    window.EventBus.$once("vtPrompt", callback);
    Notify.start(so);
  },
  error: (message) => {
    Notify.stop();
    var so = {
      title: "Error",
      body: message ? message : "Something unexpected happened!",
      type: "error"
    };
    Notify.start(so);
  },
  success: (message) => {
    Notify.stop();
    var so = {
      title: "Success",
      body: message ? message : "All is good!",
      type: "success"
    };
    Notify.start(so);
  },
  stop: () => {
    window.EventBus.$emit("vtLoadStop");
  },
  start: (so) => {
    window.EventBus.$emit("vtNotify", so);
  },
  async loadData(m, f, ...p) {
    Notify.loader(true, m);
    try {
      await f(...p);
      Notify.loader(false);
    } catch (e) {
      console.log("ERROR", e.message);
      Notify.loader(false);
      console.log("NOTIFY", e.message);
      
      Notify.error(e.message);
    }
  }

}

export default Notify;